<div class="card">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Create Transaction Report
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <!-- Date Selection Section -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Select Date Range</label>
      <div class="flex flex-wrap gap-3 items-center">
        <kendo-datepicker activeView="year" placeholder="Start Date" [size]="selectedSize" [(ngModel)]="ngModelDate"
          [fillMode]="selectedFillMode">
        </kendo-datepicker>
        <span class="text-gray-500">to</span>
        <kendo-datepicker activeView="year" placeholder="End Date" [size]="selectedSize" [(ngModel)]="ngModelendDate"
          [fillMode]="selectedFillMode">
        </kendo-datepicker>
      </div>
    </div>
    
    <!-- Report Type Selection -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Select Report Type</label>
      <kendo-dropdownlist 
        [data]="listItems" 
        textField="text" 
        (valueChange)="selectionChange($event)" 
        valueField="value"
        [(ngModel)]="selectedItem"
        class="w-full md:w-80">
      </kendo-dropdownlist>
    </div>
    
    <!-- Action Buttons -->
    <div class="mt-4">
      <!-- All Transactions (value 0) -->
      <button *ngIf="selectedValue === 0" 
        type="button" 
        class="k-button k-primary"
        [ngClass]="buttonState" 
        style="width: 200px; padding: 8px" 
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()" 
        (click)="ExportToExcel(excelexport)">
        Export All Transactions
      </button>
      
      <!-- Non-Rep Entered Transactions (value 1) -->
      <button *ngIf="selectedValue === 1"
        type="button" 
        class="k-button k-primary" 
        [ngClass]="buttonState" 
        style="width: 200px; padding: 8px"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        (click)="ExportToExcel(excelexportsummary)">
        Export Non-Rep Transactions
      </button>
      
      <!-- Summary of Non-Rep Entered Transactions (value 2) -->
      <button *ngIf="selectedValue === 2" 
        class="k-button k-primary"
        [ngClass]="buttonState" 
        style="width: 200px; padding: 8px" 
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()" 
        (click)="ExportToExcelDelete()">
        Export Transactions Summary
      </button>
      
      <!-- Deleted Blotter Transactions (value 3) -->
      <button *ngIf="selectedValue === 3"
        type="button" 
        class="k-button k-primary" 
        [ngClass]="buttonState" 
        style="width: 200px; padding: 8px"
        (mouseenter)="onMouseEnter()" 
        (mouseleave)="onMouseLeave()" 
        (click)="ExportToExcelDeleted(excelexportDeleted)">
        Export Deleted Transactions
      </button>
    </div>
    
    <div class="mt-6"></div>
    <kendo-excelexport [data]="gridExcelexport" [collapsible]="true" fileName="All_Transactions.xlsx" #excelexport>
      <kendo-excelexport-column field="blotterId" title="Transaction Id">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="firstName" title="First Name" [width]="350">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="lastName" title="LastName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="middleName" title="Middle Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="address1" title="Address1" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="address2" title="Address2" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="city" title="City" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="state" title="State" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="zipCode" title="ZipCode" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repName" title="Rep Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repCode" title="Rep Code" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productTypeDesc2" title="ProductType Description" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountNumber" title="Account Number" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="sponsorName" title="Sponsor Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="transactionTypeDesc" title="TransactionType Description" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="statusTypeDesc" title="StatusType Description" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productName" title="Product Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="amount" title="Amount" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateReceived" title="Date Received" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="AccountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedBy" title="Approved By" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedByDate" title="ApprovedBy Date" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSubmitted" title="Date Submitted" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="trackingNumber" title="Tracking Number" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSigned" title="Date Signed" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="ageAtPurchase" title="Age At Purchase" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="newAccountForm" title="NewAccount Form" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateOfNewAccountForm" title="Date Of New AccountForm" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="copyOfDl" title="CopyOfDL" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="sourceOfFundsTypeDesc" title="Source Of FundsType Desc" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="currentStatement" title="Current Statement" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSent" title="Date Sent" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="deliveryMethod" title="Delivery Method" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="checkNumber" title="Check Number" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="checkRemitter" title="Check Remitter" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="mailDate" title="Mail Date" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="documentDescription" title="Document Description" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="modifiedBy" title="Modified By" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="investmentHorizon" title="Investment Horizon" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="investmentObjectiveDesc" title="Investment ObjectiveDesc" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="lastComment" title="Last Comment" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="enteredByRep" title="Entered By Rep" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="splitRepName" title="Split Rep Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="crdbranchName" title="CRD Branch Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientTypeDesc" title="Client Type Desc" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="mutualFundClass" title="Mutual Fund Class" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="annualIncomeFrom" title="Annual Income From" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="annualIncomeTo" title="Annual Income To" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="netWorthFrom" title="Net Worth From" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="netWorthTo" title="NET Worth To" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="liquidNetworthFrom" title="Liquid Networth From" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="liquidNetworthTo" title="Liquid Networth To" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="variableAnnuityInvestmentExperience"
        title="Variable Annuity Investment Experience" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="commentsreview" title="Comments review" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="blotterReviewComments" title="Blotter Review Comments" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="blotterComments" title="Blotter Comments" [width]="50">
      </kendo-excelexport-column>
    </kendo-excelexport>
    <kendo-excelexport [data]="gridExcelexport" [collapsible]="true" fileName="Non-Rep_Entered_Transactions.xlsx"
      #excelexportsummary>
      <kendo-excelexport-column field="blotterId" title="Transaction Id">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="firstName" title="First Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="middleName" title="LastName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="lastName" title="LastName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="address1" title="Address1" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="address2" title="Address2" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="city" title="City" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="state" title="State" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="zipCode" title="ZipCode" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="taxId" title="TaxID (Last 4)" [width]="50">
      </kendo-excelexport-column>
      <!--   <kendo-excelexport-column
        field="repId"
        title="RepId"
        [width]="50"
      >
      </kendo-excelexport-column> -->
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repName" title="Rep Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repCode" title="repCode" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productTypeDesc2" title="Product Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="amount" title="Amount" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="Account Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateReceived" title="Date Received" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedBy" title="Approve By" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSubmitted" title="Date Submitted" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="trackingNumber" title="Tracking Number" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSigned" title="Date Signed" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="ageAtPurchase" title="Age of purchase" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="newAccountForm" title="New Account Form" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateOfNewAccountForm" title="Date of new account form" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="copyOfDl" title="Copy Of Dl" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="sourceOfFundsTypeDesc" title="Source of Funds type desc" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="currentStatement" title="Current Statement" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSent" title="Date sent" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="deliveryMethod" title="Delivery Method" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="checkNumber" title="Check Number" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="ageAtPurchase" title="Age of purchase" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="mailDate" title="Mail Date" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="documentDescription" title="Document Description" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="modifiedBy" title="Modified by" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="investmentHorizon" title="Investment Horizon" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="investmentObjectiveDesc" title="Investment Objective" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="lastComment" title="Last Comment" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="enteredByRep" title="Entered by rep" [width]="50">
      </kendo-excelexport-column>
      <!-- <kendo-excelexport-column
field="splitRepId"
title="Split rep Id"
[width]="50"
>
</kendo-excelexport-column> --><kendo-excelexport-column field="splitRepName" title="Split Rep name" [width]="50">
      </kendo-excelexport-column><kendo-excelexport-column field="crdbranchName" title="CRD Branch Name" [width]="50">
      </kendo-excelexport-column><kendo-excelexport-column field="clientId" title="Client ID" [width]="50">
      </kendo-excelexport-column><kendo-excelexport-column field="clientTypeDesc" title="Client Type" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="mutualFundClass" title="Mutual Fund Description" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="annualIncomeFrom" title="Annual Income from" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="annualIncomeTo" title="Annual Income to" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="netWorthFrom" title="Networth From" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="netWorthTo" title="NetWorth To" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="liquidNetworthFrom" title="Liquidnet worth from" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="liquidNetworthTo" title="Liquidnet worth to" [width]="50">
      </kendo-excelexport-column>
    </kendo-excelexport>
    <kendo-excelexport [data]="gridExcelexportDeleted" [collapsible]="true" fileName="DeletedBlotterRecordsExport.xlsx"
      #excelexportDeleted>
      <kendo-excelexport-column field="blotterId" [hidden]="false" [locked]="true" title="Transaction Id">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientId" [hidden]="false" [locked]="true" title="clientId" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productTypeDesc2" title="product Type" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="transactionTypeDesc" title="TransactionTypeId" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountNumber" title="Account Number" [width]="350">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="deletedBy" title="Deleted By" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="deletedDate" title="Deleted Date" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productName" title="ProductName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="amount" title="amount" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateReceived" title="Date Received" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.dateReceived | date : 'MM-dd-yyyy:mm:ss' }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedBy" title="ApprovedBy" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedByDate" title="approvedByDate" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.approvedByDate | date : 'MM-dd-yyyy:mm:ss' }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSubmitted" title="dateSubmitted" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.dateSubmitted | date : 'MM-dd-yyyy:mm:ss' }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="trackingNumber" title="trackingNumber" [width]="50">
      </kendo-excelexport-column>

      <kendo-excelexport-column field="dateSigned" title="dateSigned" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="newAccountForm" title="newAccountForm" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateOfNewAccountForm" title="dateOfNewAccountForm" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSubmitted" title="Date Submitted" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="statusTypeDesc" title="StatusType Desc" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="newAccountForm" title="NewAccount Form" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="blotterReviewId" title="Blotter Review  ID" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repFirstName" title="Rep First Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repMiddleName" title="Rep Middle Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repLastName" title="Rep Last Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="AccountName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="mutualFundClassBdisclosureForm" title="mutualFundClassBdisclosureForm"
        [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientFirstName" title="Client First Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientMiddleName" title="Client Middle Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientLastName" title="Client Last Name" [width]="50">
      </kendo-excelexport-column>
    </kendo-excelexport>
  </div>
</div>